module.exports = __webpack_public_path__ + "static/media/retweet-alt.cbfe3bc0.svg";